/** 0~100% 소수 입력 — "0", "0.", "0.5" 등 입력 중 문자열 허용 */

const DECIMAL_PCT_RE = /^\d*\.?\d*$/;

export function applyDecimalPctInputChange(rawValue, setValue, max = 100) {
  const raw = String(rawValue ?? '').trim();
  if (raw === '') {
    setValue(0);
    return;
  }
  if (!DECIMAL_PCT_RE.test(raw)) {
    return;
  }
  if (raw === '.' || raw.endsWith('.') || raw === '0') {
    setValue(raw);
    return;
  }
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) {
    return;
  }
  setValue(Math.min(n, max));
}

export function formatDecimalPctInputValue(v) {
  if (v === '' || v == null) {
    return '';
  }
  if (typeof v === 'string') {
    return v;
  }
  if (typeof v === 'number' && v > 0) {
    return String(v);
  }
  return '';
}

export function normalizeDecimalPctOnBlur(v, setValue, max = 100) {
  if (v === '' || v == null || v === '.' || v === '0' || v === '0.') {
    setValue(0);
    return;
  }
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) {
    setValue(0);
    return;
  }
  setValue(Math.min(n, max));
}

export function decimalPctToNumber(v) {
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? Math.min(n, 100) : 0;
}
